var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.281px",
    height: "396.85px",
    viewBox: "0 0 595.281 396.85",
    enableBackground: "new 0 0 595.281 396.85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "basket",
    fill: "#DDDDDD",
    d: "M251.788,148.819h-44.713l44.084-66.125c5.781-8.493,17.353-10.691,25.845-4.91 c8.377,5.702,10.649,17.061,5.109,25.546L251.788,148.819z M343.492,148.819h44.714l-44.083-66.125 c-5.781-8.493-17.354-10.691-25.846-4.91c-8.377,5.702-10.649,17.061-5.109,25.546L343.492,148.819z M446.458,186.024v24.803 c0.004,6.846-5.541,12.397-12.387,12.401c-0.006,0-0.01,0-0.014,0h-18.604l-10.168,101.681c-1.268,12.68-11.938,22.335-24.68,22.335 H214.674c-12.743,0-23.413-9.655-24.681-22.335l-10.168-101.681h-18.602c-6.846,0.004-12.398-5.542-12.402-12.387 c0-0.005,0-0.01,0-0.015v-24.803c-0.004-6.846,5.542-12.397,12.388-12.401c0.004,0,0.009,0,0.014,0h272.835 c6.844-0.004,12.396,5.542,12.4,12.387C446.458,186.014,446.458,186.019,446.458,186.024z M248.034,285.236h-24.803v24.804h24.803 V285.236z M248.034,223.228h-24.803v24.804h24.803V223.228z M310.042,285.236h-24.803v24.804h24.803V285.236z M310.042,223.228 h-24.803v24.804h24.803V223.228z M372.049,285.236h-24.803v24.804h24.803V285.236z M372.049,223.228h-24.803v24.804h24.803V223.228z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.f5c53e83d5f11f6f240309fc2c0f8fdc.svg";
export { ForwardRef as ReactComponent };